import { Button } from '@mui/material';
import React, { useState } from 'react';
import AuxDataApi from '../../api/AuxDataApi';
import { handleUnauthorizedResponse } from '../../api/http';
import { AuthData } from '../../context/auth';
import { withAuxDataContext } from '../../context/auxData';
import { ErrorData } from '../../context/ErrorProvider';
import DefaultDialog, { Action } from '../DefaultDialog';
import { successToast } from '../Toast';

interface Props {
	authData: AuthData;
	errorData: ErrorData;
	entityLocator: string;
	deleteKey: string;
	onConfirmCallback: () => Promise<void>;
}

const AuxDataDeleteModalTrigger = (props: Props) => {
	const { authData, errorData, entityLocator, deleteKey, onConfirmCallback } =
		props;
	const [isOpen, setIsOpen] = useState(false);
	const close = () => setIsOpen(false);
	const open = () => setIsOpen(true);
	const [loading, setLoading] = useState(false);

	const handleDeleteAuxData = async () => {
		try {
			setLoading(true);
			await AuxDataApi.deleteAuxData(
				authData.auth.authorizationToken,
				entityLocator,
				deleteKey,
			);
			await onConfirmCallback();
			successToast('Aux Data deleted');
		} catch (error) {
			errorData.handleErrorResponse(error, 'Failed to delete Aux Data');
			if (await handleUnauthorizedResponse(error, authData)) {
				return;
			}
		} finally {
			close();
			setLoading(false);
		}
	};

	const actions: Action[] = [
		{
			text: 'Confirm',
			disabled: loading,
			onClick: () => handleDeleteAuxData(),
		},
		{ text: 'Cancel', disabled: loading, onClick: close },
	];

	return (
		<>
			<Button onClick={open} size='small'>
				Delete
			</Button>
			<DefaultDialog
				actions={actions}
				open={isOpen}
				onClose={close}
				title='Delete Aux Data'
			>
				Are you sure you want to delete {`'${deleteKey}'`}?
			</DefaultDialog>
		</>
	);
};

export default withAuxDataContext<Props>(AuxDataDeleteModalTrigger);
